import Vue from 'vue'

import {BootstrapVue} from 'bootstrap-vue'
import Dialogs from "@/plugins/dialogs";
import StagesEditor from "./StagesEditor.vue";

import JsonEditor from '@kassaila/vue-json-editor';
import "@kassaila/vue-json-editor/dist/vue-json-editor.css"

Vue.component('JsonEditor', JsonEditor);
Vue.use(BootstrapVue)
Vue.use(Dialogs);

const fields = document.querySelectorAll('.stages-editor-widget');

[...fields].forEach(el => {
    new Vue({
        name: 'stages-editor-widget',
        el,
        components: {
            StagesEditor
        },
        methods: {
            setValue(value) {
                this.$refs.input.value = JSON.stringify(value)
            }
        }
    })
})

